import { Badge } from "@mantine/core";

/**
 *
 * @param {import("@mantine/core").BadgeProps} badgeProps
 * @returns
 */
export function NewBadge(badgeProps) {
	return (
		<Badge size="md" variant="outline" color="lime" {...badgeProps}>
			Nuevo
		</Badge>
	);
}
